const STORAGE_KEY = 'timetracker_default_screen'
const DEFAULT_PATH = '/tasks'

export function getDefaultScreenPath () {
  const stored = localStorage.getItem(STORAGE_KEY)
  return stored === 'timeEntries' ? '/timeEntries' : DEFAULT_PATH
}

export function setDefaultScreenFromRoute (routeName) {
  if (routeName === 'tasks' || routeName === 'timeEntries') {
    localStorage.setItem(STORAGE_KEY, routeName)
  }
}
